import { useRatingsContext } from "../contexts/Ratings";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../../../hooks/reduxHooks";
import { getTeamRatings } from "../../../../../lib/api";

const useRatingsHandlers = () => {
    const { teamId, setRatings, setFetchStatus } = useRatingsContext();
    const dispatch = useAppDispatch();

    const handleYearChange = async (year: number | undefined) => {
        setFetchStatus("pending");
        try {
            const { ratings } = await getTeamRatings(teamId, undefined, year);
            setRatings(ratings);
            setFetchStatus("success");
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: "The was a problem fetching the year's ratings.",
                    text: error,
                    dismissible: true,
                }),
            );
            setFetchStatus("failed");
        }
    };

    return { handleYearChange };
};

export default useRatingsHandlers;
